import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid } from 'redux-form'
import { FORM_INGRESO_MINIMO } from '../../../../config/forms'
import CamposIngresoMinimo
  from '../../components/iMinimo/CamposIngresoMinimo'
import IngresoMinimoSaveStatus
  from '../../components/iMinimo/IngresoMinimoSaveStatus'
import * as actions from '../../actions'
import { debounce } from '../../../../helpers/debounce'

import { INTERVALO_CORTO } from '../../../../config/settings'
import { ToastContainer } from 'react-toastify'

class FormIngresoMinimo extends Component {
  constructor (props) {
    super(props)
    this.handleConfirmStatus = this.handleConfirmStatus.bind(this)
    this.protectedFormUpdate = debounce(
      this.props.updateIminimoFormByPresunta, 1000)
  }

  componentDidMount () {
    this.props.queryMinimoBloqueado()
  }

  handleIngresoMinimoClick () {
    this.props.submitIngresoMinimoIngreso(this.props.confirmarArriboCPE)
  }

  handleConfirmStatus () {
    const {
      error
    } = this.props.iMinimoSaveStatus
    this.props.iminimoResetStatus()
    if (!error) {
      this.props.reset()
    }
  }

  handleCpaChange (e) {
    this.protectedFormUpdate(
      e.target.value, this.props.change)
  }

  render () {
    const {
      iMinimoSaveStatus,
      minimblq,
      updateByPresunta,
      procesandoCPA,
      camionPenalizado,
      motivoPenalizacion,
      vencimientoPenalizacion,
      acopladoPenalizado,
      motivoPenalizacionAcoplado,
      vencimientoPenalizacionAcoplado
    } = this.props

    let estadoForm = false

    if (minimblq === 'si') {
      estadoForm = true
    } else {
      estadoForm = false
    }

    let penalizacion
    let penalizacionAcoplado

    if (camionPenalizado && motivoPenalizacion && vencimientoPenalizacion) {
      penalizacion = {
        camionPenalizado,
        motivoPenalizacion,
        vencimientoPenalizacion
      }
    }

    if (acopladoPenalizado && motivoPenalizacionAcoplado && vencimientoPenalizacionAcoplado) {
      penalizacionAcoplado = {
        acopladoPenalizado,
        motivoPenalizacionAcoplado,
        vencimientoPenalizacionAcoplado
      }
    }

    return (
      <div id='form-ingreso-minimo'>
        <IngresoMinimoSaveStatus
          status={iMinimoSaveStatus}
          onSubmit={this.handleConfirmStatus}
          penalizacion={penalizacion}
          penalizacionAcoplado={penalizacionAcoplado}
        />
        <CamposIngresoMinimo
          onSubmit={this.handleIngresoMinimoClick.bind(this)}
          onCpaChange={this.handleCpaChange.bind(this)}
          bloqueado={estadoForm}
          procesandoCPA={procesandoCPA}
          updateByPresunta={updateByPresunta} />
        <ToastContainer autoClose={INTERVALO_CORTO} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  iMinimoSaveStatus: state.camionesIngreso.iMinimoSaveStatus,
  minimblq: state.camionesIngreso.minimblq,
  updateByPresunta: state.camionesIngreso.updateByPresunta,
  procesandoCPA: state.camionesIngreso.procesandoCPA,
  invalid: isInvalid(FORM_INGRESO_MINIMO)(state),
  camionPenalizado: state.camionesIngreso.camionPenalizado,
  vencimientoPenalizacion: state.camionesIngreso.vencimientoPenalizacion,
  motivoPenalizacion: state.camionesIngreso.motivoPenalizacion
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(
  reduxForm({ form: FORM_INGRESO_MINIMO })(FormIngresoMinimo)
)
